export default __webpack_public_path__ + "static/media/illuminate-home.f947b9a7.jpg";